module.exports = __webpack_public_path__ + "img/koltipay-bg.47d0cdfa.png";